import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { graphql, useStaticQuery } from 'gatsby'
import { AppContextProvider } from 'providers/AppContextProvider/AppContextProvider'
import { useGlobalThemeStore } from 'store/globalThemeStore/globalThemeStore'
import { ThemeProvider } from 'styled-components'

import GlobalStyle from 'theme/global.styles'
import 'theme/font.styles.css'

const query = graphql`
    query SiteTitleQuery {
        site {
            siteMetadata {
                title
            }
        }
    }
`

const RootLayout: FC = ({ children }) => {
    const [{ globalTheme }] = useGlobalThemeStore()
    const { t } = useTranslation()

    const data = useStaticQuery(query)
    const { title } = data.site.siteMetadata

    return (
        <>
            <Helmet
                title={title}
                meta={[
                    { name: 'description', content: t('meta_description') },
                    {
                        name: 'keywords',
                        content: 'MeSHPol, system MeSHPol, polish MeSH',
                    },
                    { name: 'author', content: 'Sages Sp. z o.o.' },
                    { name: 'copyright', content: 'Sages Sp. z o.o.' },
                    { property: 'og:title', content: 'MeSHPol' },
                    {
                        property: 'og:description',
                        content: t('meta_description'),
                    },
                    { property: 'og:type', content: 'website' },
                ]}
            >
                <html lang="en" />
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${
                        typeof window !== 'undefined'
                            ? window?.GATSBY_TRACKING_ID
                            : ''
                    }`}
                />
                <script>
                    {`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', typeof window !== 'undefined' ? window?.GATSBY_TRACKING_ID : '');
                    `}
                </script>
            </Helmet>
            <ThemeProvider theme={globalTheme}>
                <GlobalStyle />
                <AppContextProvider>{children}</AppContextProvider>
            </ThemeProvider>
        </>
    )
}

export default RootLayout
